<template>
    <div class="Pending">
        <Box title="维修预处理">
            <!--配件信息-->
            <div class="infoBox info">
                <p class="title">报修信息</p>
                <Field title="维修单号" type="text" :text="Repirs.WXDH" />
                <Field title="资产编号" type="text" :text="Repirs.SBBH" />
                <Field title="资产名称" type="text" :text="Repirs.SBMC" />
                <Field title="报修人" type="text" :text="Repirs.BXR" />
                <Field title="报修科室" type="text" :text="Repirs.BXKS" />
                <Field title="报修时间" type="text" :text="Repirs.BXSJ" />
                <Field title="故障问题" type="text" :text="Repirs.GZWT" />
                <Field title="故障描述" type="textarea" :text="Repirs.GZMS" :Isdisabled='true' />
                <Field title="备注" type="textarea" :text="Repirs.BXBZ" :Isdisabled='true' />
                <ImgModule upload :disabled='true'/>
            </div>
            <div class="infoBox info">
                <p class="title">预处理内容</p>
                <Field title="预计费用" :action='true' placeholder='请输入' type="number" name='number' :text="Maintain.YJFY"
                    @onMessage='value=>Maintain.YJFY=value' />
                <van-cell>
                    <template>
                        <div class="MaintainStyle">
                            <span>预计修复时间</span>
                            <div @click="IsShow=true" >
                                <span :class="Maintain.XFSJ=='请选择'?'empty':'real'">{{Maintain.XFSJ}}</span>
                                <img src="../../assets/img/right-min.png"/>
                            </div>
                        </div>
                    </template>
                </van-cell>
                <Field title="预计停机时长" placeholder='选择预计修复时间后自动计算' type="text" :text="Maintain.TJSC" />
                <Field title="故障类型" placeholder='请输入' type="manufacturer" :SelectionAndInput='true' name='faultType'
                    :text="Maintain.GZLXMC" @manuconfirm="manuconfirm('GZLX',arguments[0])" @input='inputValue(1,arguments[0])'/>

                <Field title="故障问题" placeholder='请输入' type="manufacturer" :SelectionAndInput='true' name='failureProblem'
                    :text="Maintain.GZWTMC" @manuconfirm="manuconfirm('GZWT',arguments[0])" @input='inputValue(2,arguments[0])'/>

                <Field title="解决方案" placeholder='请输入' type="manufacturer" :SelectionAndInput='true' name='solution'
                    :text="Maintain.JJFAMC" @manuconfirm="Maintain.JJFABH=arguments[0].a,Maintain.JJFAMC=arguments[0].b" @input='inputValue(3,arguments[0])'/>

                <Field title="维修意见/建议" :action='true' placeholder='请输入' type="textarea" :text="Maintain.WXYJ" @onMessage='value=>Maintain.WXYJ=value'/>
                <div style="margin-top: 50px;"></div>
            </div>

        </Box>

        <van-popup v-model="IsShow" position="bottom" round :style="{width:'100%'}">
            <van-datetime-picker title='选择时间' class="buttonColor" :min-date="minDate" type="datetime" @confirm='confirm' @cancel='cancel'/>
        </van-popup>

        <Footer v-if="!this.$route.params.ButtonExists" @save="save()" @change="change()" :button="[{text:'提交',background:'#4FA69E',color:'#FFFFFF',event:'save'},
        {text:'暂存',background:'#4FA69E',color:'#FFFFFF',event:'change'}]" />
    </div>
</template>

<script>
    import {
        GetRepairCascade
    } from '../../../tool/api/api.js'
    import {
        Cell,
        DatetimePicker,
        Popup
    } from 'vant'
    import ImgModule from '../../components/imgModule/imgModule'
    import Box from '../../components/commonBox/commonBox'
    import Footer from '../../components/footer/footer'
    import Field from '../../components/field/field'
    export default {
        name: 'Advance',
        components: {
            ImgModule,
            Box,
            Footer,
            Field,
            [Cell.name]: Cell,
            [DatetimePicker.name]: DatetimePicker,
            [Popup.name]: Popup
        },
        data() {
            return {
                minDate:new Date(this.$format(new Date(),'YYYY/MM/DD HH:mm:ss')),
                IsShow: false,
                Repirs: {
                    WXDH: this.$route.params.item.RepairOrder,
                    SBBH: this.$route.params.item.EquCode,
                    SBMC: this.$route.params.item.EquName,
                    BXR: this.$route.params.item.RepairPeople,
                    BXKS: this.$route.params.item.DepartmentName,
                    BXSJ: this.$route.params.item.RepairDate,
                    GZWT: null,
                    GZMS: null,
                    BXBZ: null
                }, //报修对象
                Maintain: {
                    XFSJ: '请选择',
                    YJFY:null,
                }, //预处理对象
            }
        },
        mounted() {
            this.loadDataDefault();
        },
        methods: {
            save() { //提交预处理记录
                this.$Dialog.confirm({
                    message: '确认提交预处理单子?'
                }).then(() => {
                    this.$get('api/Repair/UpdatePretreatment',{
                        WXBH:this.Repirs.WXDH,
                        GKHM:this.$UserInfo.UserId,
                        STORE:this.$UserInfo.StoreCode,
                        YJFY:this.Maintain.YJFY
                    }).then(result=>{
                         if(result=='Y'){
                             this.$Toast({
                                 message:'提交临床科室审核成功,请等待',
                                 duretion:2000,
                                 onClose:()=>{
                                     this.$router.back()
                                 }
                             });
                         }else this.$Toast(result);
                    })
                }).catch(() => {});
            },
            change() { //暂存预处理
                 if(!this.$verification(this.Maintain,[{id:'YJFY',name:'预计费用不能为空,请输入!'},{id:'WXYJ',name:'维修意见不能为空,请输入!'}]))return false;
                 this.Maintain.BH=this.Repirs.WXDH;
                 this.Maintain.GKHM=this.$UserInfo.UserId;
                 this.$post('api/Repair/UpdateInAdvance',this.Maintain).then(result=>{
                     this.$Toast({
                         message:result=='Y'?'预处理暂存成功,您可以继续暂存或提交预处理单!':result,
                         duration:2000
                     });
                 })
            },
            loadDataDefault() { //获取维修信息
            var that=this;
            that.$axios.all([that.$get('api/Repair/GetRepairDefault',{
                 WXBH: that.$route.params.item.RepairOrder
            }),that.$get('api/Repair/GetRepairInfo',{
                RepairNo:that.$route.params.item.RepairOrder,
                Store:that.$UserInfo.UserId,
                Token:'1235'
            })]).then(that.$axios.spread(function (result, result2) {

                try {
                    var Images= result2.RepairInfo.Images.split(',');
                    let ImageArray=[];
                    Images.forEach(function(item,index){
                        item?ImageArray.push({url:item}):'';
                    })
                    that.$Bus.$emit('YSRKDelete',ImageArray);

                    result = JSON.parse(result);
                    if (result.length != 0) {
                        result=result[0];
                        //报修内容
                        that.Repirs.GZWT = result.GZWT;
                        that.Repirs.GZMS = result.GZMS;
                        that.Repirs.BXBZ = result.BXBZ;
                        //预处理内容
                        that.Maintain.YJFY=result.YJFY;
                        that.Maintain.WXYJ=result.WXYJ;
                        that.Maintain.XFSJ=result.YJXFSJ?result.YJXFSJ.replace('T',' '):'请选择';
                        that.Maintain.TJSC=result.YJTJSC;
                        that.Maintain.GZLXBH=result.GZLXBH;
                        that.Maintain.GZLXMC=result.GZLXMC;
                        that.Maintain.GZWTBH=result.GZWTBH;
                        that.Maintain.GZWTMC=result.GZWTMC;
                        that.Maintain.JJFABH=result.JJFABH;
                        that.Maintain.JJFAMC=result.JJFAMC;
                        return false;
                    }
                    that.$Toast('数据异常,请联系管理员!');

                } catch (e) {
                    that.$Toast('系统异常,请联系管理员!');
                }
            }));


                // this.$get('api/Repair/GetRepairDefault', {
                //     WXBH: this.$route.params.item.RepairOrder
                // }).then(result => {

                // })
            },
            manuconfirm(obj, result) { //维修确认
                if (obj === 'GZLX') {
                    this.$Bus.$emit('RepairSelect', {
                        MaintainSelectIndex: result.a,
                        MaintainSelectType: obj
                    });
                    this.Maintain.GZLXBH = result.a;
                    this.Maintain.GZLXMC = result.b;
                    this.Maintain.GZWTMC = '';
                    this.Maintain.GZWTBH = '';
                } else if (obj === 'GZWT') {
                    this.$Bus.$emit('RepairSelect', {
                        MaintainSelectIndex: result.a,
                        MaintainSelectType: obj
                    });
                    this.Maintain.GZWTBH = result.a;
                    this.Maintain.GZWTMC = result.b;
                    this.Maintain.JJFABH = '';
                    this.Maintain.JJFAMC = '';
                }
            },confirm(obj){//时间选择   确认
                this.Maintain.TJSC=((obj-new Date(this.Repirs.BXSJ.replace(/-/g, "/")))/ 1000 / 60 / 60).toFixed(2);
                this.Maintain.XFSJ = this.$format(obj,'YYYY-MM-DD hh:mm:ss');
                this.IsShow=false;
            },cancel(){//时间选择   取消
                this.IsShow=false;
                this.Maintain.TJSC=null;
                this.Maintain.XFSJ='请选择'
            },inputValue(type,value){//故障类型 故障问题 解决方案
                if(type===1){
                    this.Maintain.GZLXBH=null;
                    this.Maintain.GZLXMC=value;
                }else if(type===2){
                    this.Maintain.GZWTBH=null;
                    this.Maintain.GZWTMC=value;
                }else if(type===3){
                    this.Maintain.JJFABH=null;
                    this.Maintain.JJFAMC=value;
                }
            }
        },
        watch: {

        }
    }
</script>

<style scoped lang="scss">
    .MaintainStyle {
        height: 14.933vw;
        display: flex;
        align-items: center;

        &>span{
            text-align: left;
            font-size: 4vw;
            width: 40%;
        }
        div{
            font-size:3.867vw;
            text-align: right;
            width: 60%;
            img {
                width: 4.267vw;
                height: 4vw;
                margin-left: 1.067vw
            }
        }
    }

    .empty{
       color: #969799;
    }
    .real{
        color: #323233;
    }

    .van-cell,.imgModuleBox {
        padding: 0 !important;
    }
    .imgModuleBox >>> .title{
        font-size: 4vw !important;
        font-weight: 400 !important;
    }
   .buttonColor >>> .van-picker__toolbar{
       button{
           font-size: 4.533vw !important;
           color: #4fa69e !important;
       }
    }

</style>



// WEBPACK FOOTER //
// src/page/advance/advance.vue